export default "__VITE_ASSET__ByTsluHo__"